import {  message, Select } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Form, ModalItem, FormItem, SelectItem, InputItem, ButtonItem, ErrorItem } from "../../../../../Components/Items";
import TextAreItem from "../../../../../Components/TextAreaItem";

const {Option} = Select

class AgregarUnidad extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    objetoUnidadesSat: null,
    todasUnidadesSat: null
  };
  async componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible) {
      if (this.formRef.current) this.formRef.current.resetFields();
      await this.consultarTodo(); 
      if (this.props.id) {
        this.consultarUnidadAEditar();
      }
    }
  }

  async consultarTodo() {
    this.setState({loading: true})
    await axios
    .post(
      "unidadesSat/selectUnidades",
      { empresaId: this.props.empresaId },
      { headers: this.props.headersToken }
    )
    .then((res) => {
      if (res.data.status === 404) {
      } else {
        let dataSorted = res.data.sort((a,b) => {
          if(!a.comun && b.comun){
            return 1
          }else if(a.comun && !b.comun){
            return -1
          }else{
            return 0
          }
        })
        this.setState({ todasUnidadesSat: dataSorted });
        this.setState({
          objetoUnidadesSat: dataSorted.map((value) => {
            return (
              <Option value={value._id} key={value._id}>
                {value.c_ClaveUnidad +
                  " - " +
                  value.nombre}
              </Option>
            );
          }),
        });
      }
    });
    this.setState({loading: false})
  }

  consultarUnidadAEditar() {
    this.setState({ loading: true });
    axios
      .post(
        "unidades/datosUnidad", 
        { unidadId: this.props.id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data) {
          const unidad = res.data.unidad
          this.formRef.current.setFieldsValue({
            nombre: unidad.nombre,
            descripcion: unidad.descripcion,
            unidadSatId: unidad.unidadSatId,
          });
        }
        this.setState({ loading: false });
      });
  }

  cerrarAgregarUnidad(codigo) {
    this.props.cerrarAgregarUnidad(codigo);
  }
  onFinishFailed(e) {
    ErrorItem(e);
  }
  onFinish(values) {
    this.setState({ loading: true });
    const ruta = this.props.id ? "unidades/editarUnidad" : "unidades/agregarUnidad";
    const payload = this.props.id 
      ? { ...values, empresaId: this.props.empresaId, unidadId: this.props.id } //  para editar
      : { ...values, empresaId: this.props.empresaId };                   //  para agregar

    axios
      .post(ruta, payload, { headers: this.props.headersToken })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.id || res.data.success === 2) { 
          message.success(this.props.id ? "Unidad editada correctamente" : "Se agregó una unidad");
          this.formRef.current.resetFields();
          this.cerrarAgregarUnidad();
        } else {
          message.error("Sucedio un error y no se guardo");
        }
      });
  }
  render() {
    const isEditing = !!this.props.id;
    const titleModal = isEditing ? "Editar Unidad" : "Agregar Unidad";
    const textButton = isEditing ? "Guardar" : "Agregar";
    return (
      <ModalItem
        title={titleModal}
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarAgregarUnidad.bind(this)}
        paddingTop
      >
        <Form
          ref={this.formRef}
          name="agregarUnidad"
          layout
          bottom={
            <ButtonItem
              type="primary"
              htmlType="submit"
              style={{ display: "block", margin: "0 0 0 auto" }} 
            >
              {textButton}
            </ButtonItem>
          }
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
          <FormItem
            name="nombre"
            label="Nombre"
            required
            max={100}
            margin
            pattern
          >
            <InputItem placeholder="Nombre" />
          </FormItem>
          <FormItem name="descripcion" label="Descripción" margin pattern>
            <TextAreItem placeholder="Descripción" />
          </FormItem>
          <FormItem label="Unidad Sat" name="unidadSatId" required margin>
            <SelectItem placeholder="Unidad Sat">
              {this.state.objetoUnidadesSat}
            </SelectItem>
          </FormItem>
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id
  };
};

export default connect(mapStateToProps)(AgregarUnidad);
